// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FeedbackModal.css */

/* Main Dialog Styles */
.feedback-modal-paper {
  border-radius: 24px;
}

/* Dialog Title Styles */
.feedback-modal-title {
  display: flex;
  align-items: center;
  padding: 12px 24px;
  gap: 8px;
  border-bottom: 1px solid #EBEBEB;
}

/* Dialog Content Styles */
.feedback-modal-content {
  padding: 24px !important;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Cards Container */
.feedback-cards-container {
  display: flex;
  gap: 24px;
}

@media (max-width: 600px) {
  .feedback-cards-container {
    flex-direction: column;
  }
}

/* Note: Feedback Type Card styles are now handled by StyledFeedbackCard component
   which directly accesses theme.custom.backgroundGradient */

/* Card Content Styles */
.feedback-card-content {
    display: flex;
    gap: 16px;
    padding: 20px 16px 12px;
    margin: 0;
}

.feedback-card-content:last-child {
  padding-bottom: 12px !important;
}

/* Card Header with Icon and Title */
.feedback-card-header {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

/* Card Title */
div.feedback-card-title {
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.15px;
}

/* Card Description */
div.feedback-card-description {
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.17px;
  color: #595959;
}

/* Text Field Styles */
.feedback-textarea {
  width: 100%;
}

.feedback-textarea .MuiInputLabel-root {
  color: #666666;
}

.feedback-textarea .MuiInputLabel-root.Mui-focused {
  color: #666666;
}

.feedback-textarea.error .MuiInputLabel-root {
  color: #d32f2f;
}

.feedback-textarea.error .MuiInputLabel-root.Mui-focused {
  color: #d32f2f;
}

.feedback-textarea .MuiInputLabel-asterisk {
  color: #d32f2f;
}

.feedback-textarea .MuiOutlinedInput-root {
  width: 100%;
}

.feedback-textarea .MuiOutlinedInput-root fieldset {
  border-color: #e0e0e0;
}

.feedback-textarea .MuiOutlinedInput-root:hover fieldset {
  border-color: #e0e0e0;
}

.feedback-textarea .MuiOutlinedInput-root.Mui-focused fieldset {
  border-color: #e0e0e0;
}

.feedback-textarea.error .MuiOutlinedInput-root fieldset {
  border-color: #d32f2f;
}

.feedback-textarea.error .MuiOutlinedInput-root:hover fieldset {
  border-color: #d32f2f;
}

.feedback-textarea.error .MuiOutlinedInput-root.Mui-focused fieldset {
  border-color: #d32f2f;
}

.feedback-textarea .MuiInputBase-root {
  width: 100%;
  min-height: 120px;
  padding: 16.5px 4px 16.5px 14px
}

.feedback-textarea .MuiFormControl-root {
  width: 100%;
}

.feedback-textarea textarea {
  resize: none !important;
  padding-right: 12px;
}

/* Character Count Container */
.feedback-char-count {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
}
.feedback-char-count span {
  line-height: 15.5px;
}
/* Attachment Section */
.feedback-attachment-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

h6.feedback-attachment-title {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
  line-height: 21px;
}

/* Dialog Actions */
div.feedback-modal-actions {
  display: flex;
  justify-content: space-between;
  padding: 16px 24px;
  background: #F8F8F8;
}

/* Button Styles */
button.feedback-cancel-button {
  box-shadow: none;
  text-transform: none;
  font-size: 16px;
  color: var(--button-bg-color);
}

button.feedback-submit-button {
  box-shadow: none;
  text-transform: none;
  font-size: 16px;
  background-color: var(--button-bg-color);
  color: var(--button-text-color);
}

button.feedback-submit-button:disabled {
  background-color: var(--button-bg-color);
  color: var(--button-text-color);
  opacity: 0.4;
}

/* Alert styles */
.feedback-error-alert {
  margin-top: 16px;
}

div.feedback-type-card {
    position: relative;
    display: block;
    border-radius: 16px;
    overflow: hidden;
    z-index: 0;
    cursor: pointer;
    color: #000;
    height: fit-content;
    border: 1px solid #ebebeb;
    box-shadow: none;
}

div.feedback-type-card::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background: var(--gradient-background);
  clip-path: circle(0% at 100% 0%); /* Top right corner, invisible */
  transition: clip-path 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

div.feedback-type-card:hover::before {
  clip-path: circle(150% at 92% 8%); /* Grows to fill the card */
}

div.feedback-type-card.selected {
  background: var(--gradient-background);
}

div.feedback-type-card:hover, div.feedback-type-card.selected {
    color: var(--button-text-color);
    transition-delay: 0.15s;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.20) inset;
}

div.feedback-card-icon {
    border-radius: 50%;
    background: var(--gradient-background);
    max-height: 40px;
    img {
        width: 32px;
        height: 32px;
    }
}

div.feedback-card-icon.selected {
    background: rgba(0, 0, 0, 0.25);
}

div.feedback-type-card div.feedback-card-icon {
    transition-delay: 0s; /* No delay by default */
}

div.feedback-type-card:hover div.feedback-card-icon {
    background: rgba(0, 0, 0, 0.25);
    transition-delay: 0.15s;
    /* Delay transition on hover */
}

div.feedback-type-card:hover div.feedback-card-description, div.feedback-type-card.selected div.feedback-card-description {
    color: var(--button-text-color);
    transition-delay: 0.15s;
}
`, "",{"version":3,"sources":["webpack://./src/components/FeedbackModal/FeedbackModal.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;AAClC;;AAEA,0BAA0B;AAC1B;EACE,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;4DAC4D;;AAE5D,wBAAwB;AACxB;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,SAAS;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA,eAAe;AACf;EACE,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,sCAAsC;EACtC,gCAAgC,EAAE,gCAAgC;EAClE,wDAAwD;AAC1D;;AAEA;EACE,iCAAiC,EAAE,2BAA2B;AAChE;;AAEA;EACE,sCAAsC;AACxC;;AAEA;IACI,+BAA+B;IAC/B,uBAAuB;IACvB,gDAAgD;AACpD;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,gBAAgB;IAChB;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,oBAAoB,EAAE,wBAAwB;AAClD;;AAEA;IACI,+BAA+B;IAC/B,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;IAC/B,uBAAuB;AAC3B","sourcesContent":["/* FeedbackModal.css */\n\n/* Main Dialog Styles */\n.feedback-modal-paper {\n  border-radius: 24px;\n}\n\n/* Dialog Title Styles */\n.feedback-modal-title {\n  display: flex;\n  align-items: center;\n  padding: 12px 24px;\n  gap: 8px;\n  border-bottom: 1px solid #EBEBEB;\n}\n\n/* Dialog Content Styles */\n.feedback-modal-content {\n  padding: 24px !important;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* Cards Container */\n.feedback-cards-container {\n  display: flex;\n  gap: 24px;\n}\n\n@media (max-width: 600px) {\n  .feedback-cards-container {\n    flex-direction: column;\n  }\n}\n\n/* Note: Feedback Type Card styles are now handled by StyledFeedbackCard component\n   which directly accesses theme.custom.backgroundGradient */\n\n/* Card Content Styles */\n.feedback-card-content {\n    display: flex;\n    gap: 16px;\n    padding: 20px 16px 12px;\n    margin: 0;\n}\n\n.feedback-card-content:last-child {\n  padding-bottom: 12px !important;\n}\n\n/* Card Header with Icon and Title */\n.feedback-card-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n/* Card Title */\ndiv.feedback-card-title {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n  letter-spacing: 0.15px;\n}\n\n/* Card Description */\ndiv.feedback-card-description {\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 22px;\n  letter-spacing: 0.17px;\n  color: #595959;\n}\n\n/* Text Field Styles */\n.feedback-textarea {\n  width: 100%;\n}\n\n.feedback-textarea .MuiInputLabel-root {\n  color: #666666;\n}\n\n.feedback-textarea .MuiInputLabel-root.Mui-focused {\n  color: #666666;\n}\n\n.feedback-textarea.error .MuiInputLabel-root {\n  color: #d32f2f;\n}\n\n.feedback-textarea.error .MuiInputLabel-root.Mui-focused {\n  color: #d32f2f;\n}\n\n.feedback-textarea .MuiInputLabel-asterisk {\n  color: #d32f2f;\n}\n\n.feedback-textarea .MuiOutlinedInput-root {\n  width: 100%;\n}\n\n.feedback-textarea .MuiOutlinedInput-root fieldset {\n  border-color: #e0e0e0;\n}\n\n.feedback-textarea .MuiOutlinedInput-root:hover fieldset {\n  border-color: #e0e0e0;\n}\n\n.feedback-textarea .MuiOutlinedInput-root.Mui-focused fieldset {\n  border-color: #e0e0e0;\n}\n\n.feedback-textarea.error .MuiOutlinedInput-root fieldset {\n  border-color: #d32f2f;\n}\n\n.feedback-textarea.error .MuiOutlinedInput-root:hover fieldset {\n  border-color: #d32f2f;\n}\n\n.feedback-textarea.error .MuiOutlinedInput-root.Mui-focused fieldset {\n  border-color: #d32f2f;\n}\n\n.feedback-textarea .MuiInputBase-root {\n  width: 100%;\n  min-height: 120px;\n  padding: 16.5px 4px 16.5px 14px\n}\n\n.feedback-textarea .MuiFormControl-root {\n  width: 100%;\n}\n\n.feedback-textarea textarea {\n  resize: none !important;\n  padding-right: 12px;\n}\n\n/* Character Count Container */\n.feedback-char-count {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 8px;\n}\n.feedback-char-count span {\n  line-height: 15.5px;\n}\n/* Attachment Section */\n.feedback-attachment-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\nh6.feedback-attachment-title {\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.87);\n  line-height: 21px;\n}\n\n/* Dialog Actions */\ndiv.feedback-modal-actions {\n  display: flex;\n  justify-content: space-between;\n  padding: 16px 24px;\n  background: #F8F8F8;\n}\n\n/* Button Styles */\nbutton.feedback-cancel-button {\n  box-shadow: none;\n  text-transform: none;\n  font-size: 16px;\n  color: var(--button-bg-color);\n}\n\nbutton.feedback-submit-button {\n  box-shadow: none;\n  text-transform: none;\n  font-size: 16px;\n  background-color: var(--button-bg-color);\n  color: var(--button-text-color);\n}\n\nbutton.feedback-submit-button:disabled {\n  background-color: var(--button-bg-color);\n  color: var(--button-text-color);\n  opacity: 0.4;\n}\n\n/* Alert styles */\n.feedback-error-alert {\n  margin-top: 16px;\n}\n\ndiv.feedback-type-card {\n    position: relative;\n    display: block;\n    border-radius: 16px;\n    overflow: hidden;\n    z-index: 0;\n    cursor: pointer;\n    color: #000;\n    height: fit-content;\n    border: 1px solid #ebebeb;\n    box-shadow: none;\n}\n\ndiv.feedback-type-card::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background: var(--gradient-background);\n  clip-path: circle(0% at 100% 0%); /* Top right corner, invisible */\n  transition: clip-path 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\ndiv.feedback-type-card:hover::before {\n  clip-path: circle(150% at 92% 8%); /* Grows to fill the card */\n}\n\ndiv.feedback-type-card.selected {\n  background: var(--gradient-background);\n}\n\ndiv.feedback-type-card:hover, div.feedback-type-card.selected {\n    color: var(--button-text-color);\n    transition-delay: 0.15s;\n    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.20) inset;\n}\n\ndiv.feedback-card-icon {\n    border-radius: 50%;\n    background: var(--gradient-background);\n    max-height: 40px;\n    img {\n        width: 32px;\n        height: 32px;\n    }\n}\n\ndiv.feedback-card-icon.selected {\n    background: rgba(0, 0, 0, 0.25);\n}\n\ndiv.feedback-type-card div.feedback-card-icon {\n    transition-delay: 0s; /* No delay by default */\n}\n\ndiv.feedback-type-card:hover div.feedback-card-icon {\n    background: rgba(0, 0, 0, 0.25);\n    transition-delay: 0.15s;\n    /* Delay transition on hover */\n}\n\ndiv.feedback-type-card:hover div.feedback-card-description, div.feedback-type-card.selected div.feedback-card-description {\n    color: var(--button-text-color);\n    transition-delay: 0.15s;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
